/* eslint-disable */
import React from 'react';
import b from './devsBar.module.css';
import { Ic } from './devsIcons';
import { AXIS_NAME, CHIP_AXES, STAGE_BY_KEY, axisValues, stageValues, labelOf, fmt } from './devsBarModel';

// The thin result line under the bar: "N devs of M" + one chip per chosen thing + Clear all.
// No panel — a chip is a button that removes exactly what it names.
function Chip({ k, name, children, aria, onRemove }) {
  return (
    <button type="button" className={b.chip} aria-label={`Remove ${aria || name} filter`} title={aria || name} onClick={() => onRemove(k)}>
      <span className={b.k}>{name}</span><span className={b.dt}>·</span><span>{children}</span><span className={b.x}><Ic n="x" /></span>
    </button>
  );
}

export default function DevsResultLine({ ready, matched, total, opts, devFilters, search, offline, onRemove, onClearAll, nAct }) {
  const chips = [];
  stageValues(devFilters).forEach((k) => { const s = STAGE_BY_KEY[k]; chips.push(<Chip key={`st:${k}`} k={`st:${k}`} name="Stage" aria={`Stage ${s.name}`} onRemove={onRemove}><i className={b.cd} style={{ background: s.c, '--t': s.t }} />{s.name}</Chip>); });
  if (search) chips.push(<Chip key="search" k="search" name="Search" onRemove={onRemove}>“{search}”</Chip>);
  CHIP_AXES.forEach((k) => {
    const sel = axisValues(devFilters, k); if (!sel.length) return;
    const shown = sel.slice(0, 2).map((v) => labelOf(opts, k, v)).join(', ') + (sel.length > 2 ? ` +${sel.length - 2}` : '');
    chips.push(<Chip key={k} k={k} name={AXIS_NAME[k]} aria={`${AXIS_NAME[k]} ${sel.map((v) => labelOf(opts, k, v)).join(', ')}`} onRemove={onRemove}>{shown}</Chip>);
  });
  return (
    <div className={`${b.crow} ${nAct ? '' : b.idle}`}>
      <div className={b.res} aria-live="polite">
        <b>{ready ? fmt(matched) : '–'}</b> {matched === 1 ? 'dev' : 'devs'}{nAct ? <span className={b.mu}> of {fmt(total)}</span> : null}
      </div>
      {offline && <span className={b.off} role="status"><Ic n="wifi" />Offline — numbers may be out of date</span>}
      {chips}
      {nAct ? <button type="button" className={b.clr} onClick={onClearAll}>Clear all</button> : null}
    </div>
  );
}
